<router-outlet></router-outlet>


// WEBPACK FOOTER //
// /Users/elliot/code/abc-angular/src/app/containers/simple-layout/simple-layout.component.ts.SimpleLayoutComponent.html